export default __webpack_public_path__ + "static/media/rishabh.9c563420.jpg";